import { Currency } from '@/features/offers/constants'
import { CostBudgetType, getQuotationDetailTableColumnIds, TenderDocumentStatus } from '@eapproval/offer-shared'

export const CostBudgetWorkflowStatus = {
  NOT_REQUIRED: 'Not Required',
  OPEN: 'Open',
  COMPLETED: 'Completed',
}

export const SourcingDecisionWorkflowStatus = {
  NOT_REQUIRED: '(-)',
  UPCOMING: 'Upcoming',
  ACTION_REQUIRED: 'Action Required',
  COMPLETED: 'Completed',
}

export const CostBudgetWorkflowInitiatorType = {
  TECHNICAL: 'Technical',
  PROCUREMENT: 'Procurement',
}

export const emptyQuotationTemplateRow = {
  scopeOfWork: '',
  productDescription: '',
  description: '',
  brand: '',
  modelNumber: '',
  quantity: undefined,
  unit: '',
  unitRate: undefined,
  discount: undefined,
  totalPrice: undefined,
  country: '',
  AL: '',
  ECCN: '',
  HSCode: '',
  ECCNDetail: [
    {
      description: 'VENDOR_UPLOAD_PAGE_QUESTIONNAIRE_BASIC_QUERY_2',
      selected: false,
      productName: '',
    },
    {
      description: 'VENDOR_UPLOAD_PAGE_QUESTIONNAIRE_BASIC_QUERY_3',
      selected: false,
      productName: '',
    },
    {
      description: 'VENDOR_UPLOAD_PAGE_QUESTIONNAIRE_BASIC_QUERY_4',
      selected: false,
      productName: '',
    },
  ],
  //Extra
  startDate: undefined,
  endDate: undefined,
  siteLocation: '',
  numberOfWorker: undefined,
  system: '',
}

export const initialTenderDocument = {
  status: TenderDocumentStatus.DRAFT,
  annex1: [],
  annex2: [],
  annex3: [],
  otherAnnexs: [
    {
      name: '',
      files: [],
    },
  ],
  remark: '',
  postedVendors: [],
  quotationTemplate: {
    details: [],
    currency: Currency.HKD,
    DLP: '',
    insurance: '',
    incoterm: '',
    warranty: '',
    leadTime: '',
  },
}

export const OfferQuotationDetailMaintenanceUnit = {
  MONTH: 'month',
  TIME: 'time',
  DEVICE: 'device',
  MAN_MONTH: 'man-month',
  MAN_DAY: 'man-day',
}

export const VendorActionLogType = {
  ADDENDUM_SENT: 'addendumSent',
  VENDOR_UPLOAD: 'vendorUpload',
  VENDOR_DECLINE: 'vendorDecline',
  VENDOR_REPLY_FOR_QUOTATION: 'vendorReplyForQuotation',
  VENDOR_REPLY_FOR_TECHNICAL_SUPPORT_DOCUMENT: 'vendorReplyForTechnicalSupportDocument',
  VENDOR_REPLY_FOR_UPDATE_OF_TERMS: 'vendorReplyForUpdateOfTerms',
  VENDOR_REPLY_FOR_CLARIFICATION: 'vendorReplyForClarification',
}

export const VendorActionLogRole = {
  VENDOR: 'vendor',
  INTERNAL: 'internal',
}

export const VendorActionLogTypeColor = {
  [VendorActionLogType.REQUEST_FOR_QUOTATION]: 'green',
  [VendorActionLogType.REQUEST_FOR_TECHNICAL_SUPPORT_DOCUMENT]: 'blue',
  [VendorActionLogType.REQUEST_FOR_UPDATE_OF_TERMS]: 'blue',
  [VendorActionLogType.REQUEST_FOR_CLARIFICATION]: 'blue',
  [VendorActionLogType.ADDENDUM_SENT]: 'green',
  [VendorActionLogType.VENDOR_REPLY_FOR_QUOTATION]: 'yellow',
  [VendorActionLogType.VENDOR_REPLY_FOR_TECHNICAL_SUPPORT_DOCUMENT]: 'yellow',
  [VendorActionLogType.VENDOR_REPLY_FOR_UPDATE_OF_TERMS]: 'yellow',
  [VendorActionLogType.VENDOR_REPLY_FOR_CLARIFICATION]: 'yellow',
  [VendorActionLogType.VENDOR_UPLOAD]: 'yellow',
  [VendorActionLogType.VENDOR_DECLINE]: 'red',
  [VendorActionLogType.REQUEST_FOR_DETAILED_TABLE]: 'blue',
  [VendorActionLogType.VENDOR_REPLY_FOR_DETAILED_TABLE]: 'yellow',
}

export const getInitialOfferCostBudgetDetail = (subSystem, RFQCode) => ({
  _id: '',
  subSystem: subSystem || '',
  purpose: '',
  RFQCode: RFQCode,
  requireProcurementOfficer: false,
  noticedProcurementOfficer: false,
  remark: '',

  //Tender

  tenderDocuments: [initialTenderDocument],

  internalDocuments: [],
  internalRemark: '',

  //Vendor
  CTG: undefined,
  CNI: undefined,
  isAppliedSingleSourceProcurement: false,
  singleSourceProcurementConditions: [],
  singleSourceProcurementSupportingFiles: [],

  subcontractors: [
    {
      email: '',
      name: '',
      history: [],
      emailLogs: [],

      status: 'Draft',
      creditTerm: 90,
    },
  ],

  workflow: {
    issues: [],
    status: CostBudgetWorkflowStatus.NOT_REQUIRED,
  },

  createdAt: new Date(),

  //Control
  isActive: true,
})
